import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { PopupWindowMode } from "../../../enums/popup-window-mode.enum";
import { setPopupWidth } from "../../../redux/quiz-slice";
import { Animate } from "../../animation/animation";
import styles from "./popup-window.module.scss";
import { useSize } from '../../../hooks/use-size.hook';

interface PopupWindowProps {
  active: boolean;
  onClose?: () => void;
  mode?: PopupWindowMode;
  showCloseButton?: boolean;
  scaleSettings?: Array<{ screen: number, scale: number}>;
}

export function PopupWindow(props: React.PropsWithChildren<PopupWindowProps>) {
  const { children, onClose, showCloseButton = false, mode = PopupWindowMode.DEFAULT, active, scaleSettings } = props;
  const dispatch = useDispatch();
  const animation = mode == "bottom" ? "popup_go_up" : "popup_zoom";
  const duration = mode == "bottom" ? 500 : 300;
  const { size, getNode } = useSize();
  const [scale, setScale] = useState(null);

  useEffect(() => {
    if (size?.width) dispatch(setPopupWidth(size?.width));
  }, [size?.width, dispatch]);

  useEffect(() => {
    if (scaleSettings) {
      scaleSettings.forEach(setting => {
        if (window.innerWidth >= setting.screen) setScale(setting.scale);
      });
    }
  }, [scaleSettings]);

  const closeHandler = () => {
    onClose && onClose();
  }

  return (<>
    <Animate animation="half_fade" when={active} timeout={{ appear: 0, enter: 0, exit: 600 }} unmountOnExit={true}>
      <div className={classNames(styles.underlay)} onClick={closeHandler}></div>
    </Animate>
    <Animate animation={animation} when={active} duration={duration} timeout={{ appear: 0, enter: 0, exit: 600 }} unmountOnExit={true}>
      <div className={classNames(styles.window, styles[mode])} style={{ height: `${size?.height}px`, width: `${size?.width}px`, ...((scale && active) ? { transform: `scale(${scale})` } : {}) }}>
        {showCloseButton && <div className={styles.closeButton} onClick={closeHandler}></div>}
        <div ref={getNode} className={styles.content}>{children}</div>
      </div>
    </Animate>
  </>);
}